import { Component, OnInit } from '@angular/core';
import { ModalDataService } from './modal-data.service';

@Component({
  template: '<div [innerHTML]="message"></div>'
})
export class ModalComponent implements OnInit {

  message: string;

  constructor(
    private modalDataService: ModalDataService
  ) {
    this.modalDataService.currentMessage.subscribe(message => this.message = message);
  }

  ngOnInit() {
    this.modalDataService.currentMessage.subscribe(message => this.message = message);
  }
}
